import { useTranslation } from 'react-i18next';

type PlaceholderValues = Record<string, string>;

export const useAppTranslation = (placeholders?: PlaceholderValues | null) => {
	const { t: rawT, i18n } = useTranslation();

	const t = (key: string, values?: PlaceholderValues, fallback?: string) => {
		const text = rawT(key, {
			defaultValue: fallback,
			interpolation: { escapeValue: false },
		});
		return text.replaceAll(/{(\w+)}/g, (_, key) => {
			return values?.[key] ?? placeholders?.[key] ?? `{${key}}`;
		});
	};

	return {
		t,
		i18n,
	};
};
